'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignmentV2MessageReceived = assignmentV2MessageReceived;

var _getters = require('conversations-schema/operators/assignment-message/getters');

var _getAssigneeIdForAssignmentMessage = require('conversations-schema/operators/assignment-message/getAssigneeIdForAssignmentMessage');

var _findResponderByIdFromList = require('conversations-schema/responders/operators/findResponderByIdFromList');

var _AgentResponderActions = require('./AgentResponderActions');

var _defaultMessageReceived = require('./defaultMessageReceived');

var _getAllAgentResponders = require('../responders/selectors/getAllAgentResponders');

function assignmentV2MessageReceived(message, channel) {
  return function (dispatch, getState) {
    var assignedAgentId = (0, _getAssigneeIdForAssignmentMessage.getAssigneeIdForAssignmentMessage)(message);
    var responders = (0, _getAllAgentResponders.getAllAgentResponders)(getState());
    var newlyAssignedResponder = (0, _findResponderByIdFromList.findResponderByIdFromList)({
      responders: responders,
      responderId: assignedAgentId
    });

    var shouldFetchResponder = assignedAgentId && !newlyAssignedResponder;

    if (shouldFetchResponder) {
      dispatch((0, _AgentResponderActions.fetchAgentResponder)({
        senderId: assignedAgentId,
        agentType: (0, _getters.getAssignedAgentType)(message)
      }));
    }

    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/assignmentV2MessageReceived.js
// module id = 590
// module chunks = 2 3